module.exports = __webpack_public_path__ + "img/train_black_24dp.6b04a292.svg";